<template>
  <div>
    <SubTitleView>{{ $t("profilePage.etablissement.chef") }}</SubTitleView>
    <InputWithValidation
      v-model="localEtablissement.nomChefEtablissement"
      rules="required"
      :label="$t(`profilePage.etablissement.chef-nom`)"
      :placeholder="$t(`profilePage.etablissement.chef-nom`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="nomChefEtablissement"
      @manual-change="updateEtablissementChefEtablissement"
    />
    <InputWithValidation
      v-model="localEtablissement.prenomChefEtablissement"
      rules="required"
      :label="$t(`profilePage.etablissement.chef-prenom`)"
      :placeholder="$t(`profilePage.etablissement.chef-prenom`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="prenomChefEtablissement"
      @manual-change="updateEtablissementChefEtablissement"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import SubTitleView from "@/views/commons/SubTitleView.vue"
import { EtablissementDTO } from "@/model/bean/GeneratedDTOs"

export default defineComponent({
  name: "EtablissementChefDetails",
  components: {
    InputWithValidation,
    SubTitleView,
  },
  props: {
    etablissement: {
      type: Object as PropType<EtablissementDTO>,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    validationGroup: {
      type: String,
      default: "",
    },
  },

  emits: ["update-etablissement"],
  data() {
    return {
      localEtablissement: { ...this.etablissement } as EtablissementDTO,
    }
  },
  watch: {
    etablissement: {
      handler(newVal: EtablissementDTO) {
        this.localEtablissement = { ...newVal }
      },
      deep: true,
    },
  },
  methods: {
    updateEtablissementChefEtablissement(): void {
      this.$emit("update-etablissement", this.localEtablissement)
    },
  },
})
</script>
